import * as types from '../../index';


export const clientCategoryMasterListAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_MASTER_LIST,
    data
    }
};


export const clientCategoryMasterAddAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_MASTER_ADD,
    data
    }
};

export const clientCategoryMasterEditAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_MASTER_EDIT,
    data
    }
};

export const clientCategoryMasterUpdateAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_MASTER_UPDATE,
    data
    }
};

export const clientCategoryMasterDeleteAction = (data) => {
    return {
    type: types.CLIENT_CATEGORY_MASTER_DELETE,
    data
    }
};